import React from "react";
import PropTypes from "prop-types";
import { DISPLAY_NAME_ACTIONS } from "./constants";

const PageActions = ({ children, dataTestId }) =>
  children !== null ? (
    <div data-testid={dataTestId} className="oui-header-right">
      {children}
    </div>
  ) : null;

PageActions.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  dataTestId: PropTypes.string
};

PageActions.defaultProps = {
  dataTestId: "orion-page-actions"
};

PageActions.displayName = DISPLAY_NAME_ACTIONS;

export default PageActions;
